var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { INDEXED_DB_BACKUP_SCHEDULES, LOCAL_STORAGE_DEVICE_UNIQUE } from 'renderer/constants';
import { db } from './dexieDB';
import { createNanoId } from './nanoid';
import { ScheduleModel } from 'renderer/models';
import { isEmpty } from 'lodash';
import { LocalStorage } from './localstorage';
// @deprecated
var LOCAL_STORAGE_BACKUP_SCHEDULES = 'LOCAL_STORAGE_BACKUP_SCHEDULES';
// 데이터 저장
export function setItem(key, value) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!!value) return [3 /*break*/, 2];
                    return [4 /*yield*/, db.KeyValueStore.put({ key: key, value: value })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
// 데이터 조회
export function getItem(key) {
    return __awaiter(this, void 0, Promise, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, db.KeyValueStore.get(key)];
                case 1:
                    result = _a.sent();
                    if (!result) {
                        return [2 /*return*/, LocalStorage.get(key)];
                    }
                    return [2 /*return*/, result.value];
            }
        });
    });
}
// 디바이스 고유값 조회 및 생성
export function getDeviceUnique() {
    return __awaiter(this, void 0, Promise, function () {
        var deviceUnique, deviceUnique1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getItem(LOCAL_STORAGE_DEVICE_UNIQUE)];
                case 1:
                    deviceUnique = _a.sent();
                    return [4 /*yield*/, getItem(undefined)];
                case 2:
                    deviceUnique1 = _a.sent();
                    if (!!deviceUnique) return [3 /*break*/, 4];
                    deviceUnique = deviceUnique1 || "".concat(createNanoId(), "_").concat(Date.now());
                    // DexieDB에 값 저장
                    return [4 /*yield*/, setItem(LOCAL_STORAGE_DEVICE_UNIQUE, deviceUnique)];
                case 3:
                    // DexieDB에 값 저장
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/, String(deviceUnique)];
            }
        });
    });
}
// 데이터 삭제
export function removeItem(key) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, db.KeyValueStore.delete(key)];
                case 1:
                    _a.sent();
                    LocalStorage.removeItem(key);
                    return [2 /*return*/];
            }
        });
    });
}
// 전체 데이터 삭제
export function clearStore() {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, db.KeyValueStore.clear()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
// 모든 데이터 가져오기 (디버깅/테스트 용도)
export function getAllItems() {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, db.KeyValueStore.toArray()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
// 데이터를 만료 시간과 함께 저장
export function setWithExpiryToDB(key, value, ttl) {
    return __awaiter(this, void 0, Promise, function () {
        var item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    item = {
                        value: value,
                        expiry: new Date().getTime() + ttl, // 현재 시간 + TTL(ms)
                    };
                    // DexieDB에 저장
                    return [4 /*yield*/, setItem(key, item)];
                case 1:
                    // DexieDB에 저장
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
// 만료 시간을 고려하여 데이터 가져오기
export function getWithExpiryFromDB(key) {
    return __awaiter(this, void 0, Promise, function () {
        var item, isExpired;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getItem(key)];
                case 1:
                    item = _a.sent();
                    if (!item)
                        return [2 /*return*/, null];
                    isExpired = new Date().getTime() > item.expiry;
                    if (!isExpired) return [3 /*break*/, 3];
                    // 만료된 데이터 삭제
                    return [4 /*yield*/, removeItem(key)];
                case 2:
                    // 만료된 데이터 삭제
                    _a.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/, item];
            }
        });
    });
}
// DexieDB에서 스케줄 가져오기
export var getScheduleFromDB = function () { return __awaiter(void 0, void 0, Promise, function () {
    var items;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, db.KeyValueStore.get(INDEXED_DB_BACKUP_SCHEDULES)];
            case 1:
                items = ((_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.value) || JSON.parse(localStorage.getItem(LOCAL_STORAGE_BACKUP_SCHEDULES));
                // 데이터가 없으면 빈 배열 반환
                return [2 /*return*/, (items === null || items === void 0 ? void 0 : items.map(function (item) { return new ScheduleModel(item); })) || []];
        }
    });
}); };
export var setScheduleToDB = function (items) { return __awaiter(void 0, void 0, Promise, function () {
    var today, startRange, endRange, storeId, filtered, existingSchedules, scheduleMap, mergedSchedules;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                // 데이터가 비어있으면 중단
                if (isEmpty(items)) {
                    return [2 /*return*/];
                }
                today = new Date();
                startRange = new Date(today);
                endRange = new Date(today);
                storeId = items[0].storeId;
                startRange.setDate(today.getDate() - 5);
                endRange.setDate(today.getDate() + 5);
                filtered = function (_a) {
                    var dateOption = _a.dateOption, itemStoreId = _a.storeId;
                    var scheduleDate = new Date(dateOption.startedAt);
                    return (scheduleDate >= startRange &&
                        scheduleDate <= endRange &&
                        itemStoreId === storeId);
                };
                return [4 /*yield*/, db.KeyValueStore.get(INDEXED_DB_BACKUP_SCHEDULES)];
            case 1:
                existingSchedules = ((_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.value) || JSON.parse(localStorage.getItem(LOCAL_STORAGE_BACKUP_SCHEDULES) || '[]');
                scheduleMap = new Map();
                __spreadArray(__spreadArray([], existingSchedules, true), items, true).filter(filtered).forEach(function (schedule) {
                    scheduleMap.set(schedule.id, schedule);
                });
                mergedSchedules = Array.from(scheduleMap.values());
                return [4 /*yield*/, setItem(INDEXED_DB_BACKUP_SCHEDULES, mergedSchedules)];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}); };
